import React from 'react';
import './index.scss';

export const MonitoringPaper = ({ children, style }) => {
  return (
    <div className="monitoring-paper" style={style}>
      {children}
    </div>
  );
};
